
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grocery/hypermarkets-pos-billing-software",
      function () {
        return require("private-next-pages/grocery/hypermarkets-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grocery/hypermarkets-pos-billing-software"])
      });
    }
  